import { Box } from '@mui/material';
import { standardIcons } from './NIconsSVG';
import { nIcon } from './NIcon.styles';

export type NIconSize = 'sm' | 'md';

export type NIconName =
  | 'alerts-feedback'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-square-out'
  | 'arrows-clockwise'
  | 'arrows-down-up-stroke'
  | 'book-open'
  | 'calendar'
  | 'camera'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-up'
  | 'chalkboard-teacher'
  | 'check-circle-fill'
  | 'check-circle-stroke'
  | 'check-stroke'
  | 'clock'
  | 'closed-captioning'
  | 'cross-circle-stroke'
  | 'cross-stroke'
  | 'cross-circle-fill'
  | 'crosshair'
  | 'dots-three-stroke'
  | 'dots-three-vertical-stroke'
  | 'download-stroke'
  | 'drag'
  | 'exam'
  | 'eye'
  | 'eye-slash'
  | 'facebook'
  | 'fast-forward'
  | 'filter-stroke'
  | 'gear-fine-stroke'
  | 'globe-hemisphere-east'
  | 'globe-hemisphere-west'
  | 'graduation-cap'
  | 'handshake'
  | 'house'
  | 'image-square'
  | 'info-fill'
  | 'info-stroke'
  | 'instagram'
  | 'key-return'
  | 'lifebuoy'
  | 'linkedin'
  | 'list-bullets'
  | 'list'
  | 'list-numbers'
  | 'loading'
  | 'lock-key'
  | 'magnifying-glass'
  | 'map-pin'
  | 'microphone'
  | 'minus'
  | 'notches'
  | 'pause'
  | 'play'
  | 'plus'
  | 'question-fill'
  | 'question-stroke'
  | 'quotes'
  | 'robot'
  | 'scan'
  | 'seal'
  | 'share'
  | 'share-network-stroke'
  | 'sign-out'
  | 'sign-in-stroke'
  | 'skip-back'
  | 'sparkle'
  | 'speaker'
  | 'speaker-low'
  | 'speaker-slash'
  | 'student'
  | 'star-fill'
  | 'star-stroke'
  | 'text-align-left'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'trend-up'
  | 'user-circle'
  | 'user'
  | 'watch'
  | 'wrench-stroke'
  | 'x'
  | 'youtube'
  | 'warning-fill'
  | 'warning-stroke'
  | 'wifi-slash'
  | 'link-simple'
  | 'alerts-feedback-fill'
  | 'copy'
  | 'lightbulb'
  | 'presentation-chart'
  | 'list-checks'
  | 'text-aa'
  | 'door-open'
  | 'chat-circle-dots'
  | 'user-sound'
  | 'clock-counter-clockwise'
  | 'thumbs-down-fill'
  | 'thumbs-up-fill'
  | 'check-bold'
  | 'pencil'
  | 'file-x'
  | 'file-x-fill'
  | 'file-arrow-down-fill'
  | 'file-arrow-down'
  | 'trash'
  | 'trash-fill'
  | 'plus-square'
  | 'plus-square-fill'
  | 'list-checks-fill'
  | 'image-square-fill'
  | 'placeholder'
  | 'speedometer'
  | 'zhihu'
  | 'xiaohongshu'
  | 'weibo'
  | 'bilibili'
  | 'users-three'
  | 'briefcase'
  | 'pearson-logo'
  | 'writing'
  | 'file-pdf'
  | 'audio'
  | 'file-doc'
  | 'game'
  | 'folder'
  | 'music'
  | 'undo'
  | 'redo'
  | 'bold'
  | 'italic'
  | 'align-center'
  | 'align-justify'
  | 'align-right'
  | 'smile'
  | 'arrows-clockwise-user';

export type IconKey = `${NIconName}-${NIconSize}`;

interface NIconProps {
  name: NIconName;
  size?: NIconSize;
  color?: string;
}

export const NIcon = ({ name, size = 'md', color }: NIconProps) => {
  const iconKey: IconKey = `${name}-${size}`;
  const iconSvg = standardIcons[iconKey];

  return (
    <Box sx={{ ...nIcon(size), ...(color ? { color } : {}) }}>
      {iconSvg && iconSvg.length > 0 && (
        <svg
          width={size === 'sm' ? '16' : '24'}
          height={size === 'sm' ? '16' : '24'}
          viewBox={size === 'sm' ? '0 0 16 16' : '0 0 24 24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id={iconKey}>
            {iconSvg.map((pathD: string) => (
              <path key={pathD} id='Vector' d={pathD} fill='currentColor' />
            ))}
          </g>
        </svg>
      )}
    </Box>
  );
};
